import { computed } from "vue";
import { translate } from "@/plugins/i18n";
import Key from "@/app/types/common/key";

export interface BmLabelledProps {
  label?: string | null;
  tooltip?: string | null;
  t?: Key;
  dataQa?: object | string;
}

export const useBmLabelled = (props: () => BmLabelledProps) => {
  const tooltipVal = computed((): string => {
    const { tooltip, t } = props();

    return tooltip || (t ? translate(Key.fromString(t.value + "_hint")) : "");
  });

  const labelVal = computed((): string => {
    const { label, t } = props();
    return label || (t ? translate(t) : "");
  });

  const dataQaVal = computed((): string | undefined => {
    const { dataQa, t, label } = props();
    return dataQa?.toString() || t?.value || label || undefined;
  });

  return {
    tooltipVal,
    labelVal,
    dataQaVal,
  };
};
